import { axios } from "@Root/API";

export const saveColumnOptions = (contactType, options) => {
  const payload = {
    entity: contactType,
    properties: options
  };
  return axios.post("page-setting/columns", payload);
};
